import { useMonitor } from '../use-monitor';

export function useMonitorDeclineActionSubmit() {
  return useMonitor('decline-action-submit');
}
